module.exports = __webpack_public_path__ + "025c321a974bc3d50e34290f112bb93b.svg";